'use client';
import dynamic from 'next/dynamic';
import React from 'react';

// Dynamically import the client-only component
const CaseStatics = dynamic(() => import('./CaseStatics'), {
  ssr: false,
  loading: () => <p>Loading chart...</p>,
});

const CaseStaticsClientWrapper = (props) => {
  return <CaseStatics {...props} />;
};

export default CaseStaticsClientWrapper;
